import React from 'react';
import { Box, Typography } from '@mui/material';

export const OrderDetailsPanel = ({ order, searchType, weatherData }) => {
  if (!order) return null;

  return (
    <Box sx={{ 
      alignSelf: 'stretch',
      pt: '10px',
      pb: '15px',
      pl: '10px',
      pr: '10px',
      background: '#D9D5D1',
      boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.15)',
      borderRadius: '8px',
      display: 'flex',
      flexDirection: 'column',
      gap: '10px'
    }}>
      <Box sx={{
        alignSelf: 'stretch',
        pb: '10px',
        borderBottom: '1px solid #B7B3AE',
        display: 'flex',
        flexDirection: 'column',
        gap: '5px'
      }}>
        <Box sx={{
          alignSelf: 'stretch',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <Box sx={{ flex: 1 }}>
            <Typography sx={{
              color: '#666666',
              fontSize: '9px',
              fontFamily: "'Space Grotesk', sans-serif",
              fontWeight: 700,
              textTransform: 'uppercase',
              lineHeight: '10px'
            }}>
              SEARCH DETAIL
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box sx={{
        alignSelf: 'stretch',
        pl: '8px',
        pr: '8px',
        display: 'flex',
        flexDirection: 'column',
        gap: '6px'
      }}>
        {/* Top row: Grade search shows Grade and Material Number; Process order search shows Order Number and Grade */}
        <Box sx={{
          alignSelf: 'stretch',
          display: 'flex',
          gap: '6px'
        }}>
          {searchType === 'processOrder' ? (
            <>
              <Box sx={{ flex: 1 }}>
                <Typography sx={{
                  color: '#4D4D4D',
                  fontSize: '11px',
                  fontFamily: "'Space Grotesk', sans-serif",
                  fontWeight: 400,
                  lineHeight: '13px'
                }}>
                  Order Number
                </Typography>
                <Typography sx={{
                  color: '#1F1F1F',
                  fontSize: '15px',
                  fontFamily: "'Space Grotesk', sans-serif",
                  fontWeight: 400,
                  lineHeight: '19px'
                }}>
                  {order.processOrder}
                </Typography>
              </Box>
              <Box sx={{ flex: 1 }}>
                <Typography sx={{
                  color: '#4D4D4D',
                  fontSize: '11px',
                  fontFamily: "'Space Grotesk', sans-serif",
                  fontWeight: 400,
                  lineHeight: '13px'
                }}>
                  Grade
                </Typography>
                <Typography sx={{
                  color: '#1F1F1F',
                  fontSize: '15px',
                  fontFamily: "'Space Grotesk', sans-serif",
                  fontWeight: 400,
                  lineHeight: '19px'
                }}>
                  {order.grade}
                </Typography>
              </Box>
            </>
          ) : (
            <>
              <Box sx={{ flex: 1 }}>
                <Typography sx={{
                  color: '#4D4D4D',
                  fontSize: '11px',
                  fontFamily: "'Space Grotesk', sans-serif",
                  fontWeight: 400,
                  lineHeight: '13px'
                }}>
                  Grade Search
                </Typography>
                <Typography sx={{
                  color: '#1F1F1F',
                  fontSize: '15px',
                  fontFamily: "'Space Grotesk', sans-serif",
                  fontWeight: 400,
                  lineHeight: '19px'
                }}>
                  {order.grade}
                </Typography>
              </Box>
            </>
          )}
        </Box>

        {/* Moisture Grain */}
        <Box sx={{ flex: 1 }}>
          <Typography sx={{
            color: '#4D4D4D',
            fontSize: '11px',
            fontFamily: "'Space Grotesk', sans-serif",
            fontWeight: 400,
            lineHeight: '13px'
          }}>
            Moisture Grain
          </Typography>
          <Typography sx={{
            color: '#1F1F1F',
            fontSize: '15px',
            fontFamily: "'Space Grotesk', sans-serif",
            fontWeight: 400,
            lineHeight: '19px'
          }}>
            {order.moistureGrain}
          </Typography>
        </Box>

        {/* For process order search, show Material Number on its own row */}
        {searchType === 'processOrder' && (
          <Box sx={{ flex: 1 }}>
            <Typography sx={{
              color: '#4D4D4D',
              fontSize: '11px',
              fontFamily: "'Space Grotesk', sans-serif",
              fontWeight: 400,
              lineHeight: '13px'
            }}>
              Material Number
            </Typography>
            <Typography sx={{
              color: '#1F1F1F',
              fontSize: '15px',
              fontFamily: "'Space Grotesk', sans-serif",
              fontWeight: 400,
              lineHeight: '19px'
            }}>
              {order.materialNumber}
            </Typography>
          </Box>
        )}

        {/* Weather Information */}
        {weatherData && (
          <Box sx={{
            alignSelf: 'stretch',
            display: 'flex',
            flexDirection: 'column',
            gap: '6px'
          }}>
            <Box sx={{
              alignSelf: 'stretch',
              display: 'flex',
              gap: '6px'
            }}>
              <Box sx={{ flex: 1 }}>
                <Typography sx={{
                  color: '#4D4D4D',
                  fontSize: '11px',
                  fontFamily: "'Space Grotesk', sans-serif",
                  fontWeight: 400,
                  lineHeight: '13px'
                }}>
                  Temperature
                </Typography>
                <Typography sx={{
                  color: '#1F1F1F',
                  fontSize: '15px',
                  fontFamily: "'Space Grotesk', sans-serif",
                  fontWeight: 400,
                  lineHeight: '19px'
                }}>
                  {weatherData.temperature}°F
                </Typography>
              </Box>
              <Box sx={{ flex: 1 }}>
                <Typography sx={{
                  color: '#4D4D4D',
                  fontSize: '11px',
                  fontFamily: "'Space Grotesk', sans-serif",
                  fontWeight: 400,
                  lineHeight: '13px'
                }}>
                  Humidity
                </Typography>
                <Typography sx={{
                  color: '#1F1F1F',
                  fontSize: '15px',
                  fontFamily: "'Space Grotesk', sans-serif",
                  fontWeight: 400,
                  lineHeight: '19px'
                }}>
                  {weatherData.relativeHumidity}%
                </Typography>
              </Box>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
}; 